import { useSearchParams as useRRSearchParams } from 'react-router-dom';

// next/navigation's useSearchParams() returns a ReadonlyURLSearchParams directly;
// react-router-dom's returns a [params, setParams] tuple. We unwrap to the
// URLSearchParams instance so call sites like `searchParams.get('id')` work
// unchanged.
export function useSearchParams() {
  const [searchParams] = useRRSearchParams();
  return searchParams;
}
